import { baseUrl, getHeaders } from "../common-package/url";
import { getNonNullUser } from "../common-package/user";

export const downloadUsers = async () => {
  try {
    const { token } = getNonNullUser();
    const responseFetch = await fetch(`${baseUrl}/PowernetHub/Users`, {
      method: "GET",
      headers: getHeaders(token),
    });
    if (!responseFetch.ok) {
      return {
        error: "Invalid request",
      };
    }
    return responseFetch.json();
  } catch (ex) {
    return {
      error: "Exception error",
    };
  }
};

export const downloadFile = async (
  userId: number,
  from: Date | null,
  to: Date | null
): Promise<Blob | { error: string }> => {
  try {
    if (userId) {
      const { token } = getNonNullUser();
      const responseFetch = await fetch(
        `${baseUrl}/PowernetHub/Trainee-Report/pdf?userId=${userId}&from=${
          from?.toISOString().split("T")[0]
        }&to=${to?.toISOString().split("T")[0]}`,
        {
          method: "GET",
          headers: getHeaders(token),
        }
      );
      if (!responseFetch.ok) {
        return {
          error: "Invalid request",
        };
      }
      return responseFetch.blob();
    }
    return {
      error: "No user id",
    };
  } catch (ex) {
    return {
      error: "Exception error",
    };
  }
};
